var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"game-header"},[_c('div',{staticClass:"stat-container stat-left"},[_c('div',{staticClass:"icon"},[_c('ClockIcon')],1),_c('label',[_vm._v(":"+_vm._s(_vm.formattedTime))])]),_c('div',{staticClass:"stat-container stat-right"},[_c('label',[_vm._v(_vm._s(_vm.score))]),_c('div',{staticClass:"icon"},[_c('GemIcon')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }